import { render, staticRenderFns } from "./bar_index.vue?vue&type=template&id=70f0d9c4&scoped=true"
import script from "./bar_index.vue?vue&type=script&lang=js"
export * from "./bar_index.vue?vue&type=script&lang=js"
import style0 from "./bar_index.vue?vue&type=style&index=0&id=70f0d9c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f0d9c4",
  null
  
)

export default component.exports